import handleLoginPrompt from './handlers/login-prompt-handler';

export default (): void => {
  handleLoginPrompt();
};
